// extracted by mini-css-extract-plugin
export default {"liveFaq":"live-faq-module--liveFaq--NcuOF","item":"live-faq-module--item--u3YUh"};